var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSixtLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 30,
    viewBox: "0 0 76 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_31_170)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_31_170)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.8078 1.93994H39.7376C38.387 4.96039 35.8326 6.49793 31.2014 7.07682C29.9569 7.23893 28.3539 7.25744 27.2564 7.25744C26.9254 7.25744 26.601 7.25563 26.2905 7.25315V12.3607H29.1559C31.4155 12.3607 34.7712 12.0794 37.926 10.7389C41.8809 9.05846 44.5972 6.07505 45.8878 1.93994H39.8078Z",
    fill: "#FF5000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.5905 17.4531L37.2596 13.3542C37.7208 13.1966 38.2187 13.0031 38.6499 12.8209C40.1369 12.193 41.4773 11.275 42.6518 10.3172L44.4942 12.9602L49.4019 6.25008L70 6.24985V11.4676H63.9027V27.6458H57.7249V11.4676H52.8599H52.81L52.7813 11.5082L48.5744 17.4561L56.6566 27.6458H48.9837L44.4978 21.5313L39.7822 27.6458H26.2906V14.4523H32.3385V27.4449L40.5905 17.4531ZM15.4165 5.77979C7.23683 5.77979 6.0059 10.1082 6.00002 12.6883C5.98761 18.2984 10.6499 18.9704 14.3962 19.5104C16.7698 19.8525 18.6447 20.1227 18.6447 21.5844C18.6447 22.8445 17.3334 23.4324 14.5179 23.4344C12.1644 23.4344 9.45419 22.9239 6.23619 21.8741V26.9014C8.38898 27.7614 11.1076 28.1798 14.5437 28.1798C21.4558 28.1486 24.8161 25.8606 24.8161 21.1852C24.8161 15.6063 20.0924 14.928 16.2968 14.383C13.8727 14.0349 11.9578 13.7599 11.9578 12.2815C11.9578 10.7602 13.8487 10.441 15.435 10.441C17.9655 10.441 21.1899 11.2996 23.4942 12.0381V7.01636C20.569 6.18438 17.9263 5.77979 15.4165 5.77979Z",
    fill: "#1A1A1A"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_31_170"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 76,
    height: 30,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_31_170"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 26.24,
    fill: "white",
    transform: "translate(6 1.93994)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSixtLogo);
export default __webpack_public_path__ + "static/media/sixt-logo.c5f962b984defbb3a8fe9f33991eb0f8.svg";
export { ForwardRef as ReactComponent };